import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
} from "@coreui/react";

import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import {
  createRoute,
  getSingleRoute,
  updateRoute,
} from "../../services/route.services";
import {
  getStoreList,
  getSearchableStoreList,
  getNoRouteStores,
} from "../../services/store.services";
import { getRoutePointList } from "../../services/route-point.services";
import { useParams } from "react-router-dom";
import { cilArrowThickRight, cilArrowThickLeft } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { getActiveCountryList } from "src/services/country.services";
import ReactSelect from "react-select";

const schema = z
  .object({
    name: z.string().min(1, "Required"),
    routeCode: z.string().optional(),
    startingPoint: z.string().optional(),
    endingPoint: z.string().optional(),
    distance: z.string().optional(),
    startTime: z.string().optional(),
    duration: z.string().optional(),
    tripType: z.string().optional(),
    stores: z.array(z.any()).optional(),
    country: z.string().optional(),
    tripUrgency: z.string().min(1, "Required"),
    routeType: z.string().min(1, "Required"),
  })
  .refine(
    ({
      tripUrgency,
      tripType,
      routeType,
      startingPoint,
      endingPoint,
      stores,
      routeCode,
      distance,
      startTime,
      duration,
    }) => {
      if (tripUrgency === "normal" && routeType === "single") {
        // (!startingPoint ||
        //   !endingPoint ||
        //   !stores ||
        //   !routeCode ||
        //   !distance ||
        //   !startTime ||
        //   !duration)

        if (!routeCode) {
          throw new z.ZodError([
            {
              path: ["routeCode"],
              message: "Required",
            },
          ]);
        }

        if (!tripType) {
          throw new z.ZodError([
            {
              path: ["tripType"],
              message: "Required",
            },
          ]);
        }
        if (!startingPoint) {
          throw new z.ZodError([
            {
              path: ["startingPoint"],
              message: "Required",
            },
          ]);
        }

        if (!endingPoint) {
          throw new z.ZodError([
            {
              path: ["endingPoint"],
              message: "Required",
            },
          ]);
        }
        if (stores.length <= 0) {
          throw new z.ZodError([
            {
              path: ["stores"],
              message: "Required",
            },
          ]);
        }

        if (!startTime) {
          throw new z.ZodError([
            {
              path: ["startTime"],
              message: "Required",
            },
          ]);
        }

        if (!duration) {
          throw new z.ZodError([
            {
              path: ["duration"],
              message: "Required",
            },
          ]);
        }

        if (!distance) {
          throw new z.ZodError([
            {
              path: ["distance"],
              message: "Required",
            },
          ]);
        }

        // throw new z.ZodError([
        //   {
        //     path: ["routeCode"],
        //     minimum: 1,
        //     message: "Required",
        //   },
        //   {
        //     path: ["distance"],
        //     message: "Required",
        //   },
        //   {
        //     path: ["startTime"],
        //     message: "Required",
        //   },
        //   {
        //     path: ["duration"],
        //     message: "Required",
        //   },
        //   {
        //     path: ["startingPoint"],
        //     message: "Required",
        //   },
        //   {
        //     path: ["endingPoint"],
        //     message: "Required",
        //   },
        //   {
        //     path: ["stores"],
        //     message: "Required",
        //   },
        // ]);
      }
      return true;
    }
  );

const CreateRoute = () => {
  const [localUser, setLocalUser] = useState(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );
  const [selectedStartingPointOption, setSelectedStartingPointOption] =
    useState(null);
  const [selectedEndingPointOption, setSelectedEndingPointOption] =
    useState(null);
  const [pointOptions, setPointOptions] = useState([]);
  const [selectedTripTypeOption, setSelectedTripTypeOption] = useState(null);
  const [tripTypeOptions, setTripTypeOptions] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [toStoreOptions, setToStoreOptions] = useState([]);

  const [routePointId, setRouteId] = useState("");
  const [routePointData, setRouteData] = useState(null);
  const { id } = useParams();

  const [selectedStoreFromOptions, setSelectedStoreFromOptions] = useState([]);
  const [selectedStoreToOptions, setSelectedStoreToOptions] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countrySelectOptions, setCountrySelectOptions] = useState([]);
  const [selectedTripUregnecyOption, setSelectedTripUrgencyOption] = useState({
    value: "normal",
    label: "Normal",
  });

  const [routeType, setRouteType] = useState({
    value: "single",
    label: "Same Route",
  });

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      routeCode: "",
      startingPoint: "",
      endingPoint: "",
      distance: "",
      startTime: "",
      duration: "",
      tripType: "",
      tripUrgency: selectedTripUregnecyOption.value,
      stores: [],
      country: "",
      routeType: routeType.value,
    },
    mode: "onBlur",
    reValidateMode: "onChange",
    criteriaMode: "all",
    shouldUseNativeValidation: false,
    resolver: zodResolver(schema),
  });

  const handleStoreFromSelectChange = (event) => {
    const { options } = event.target;
    const selectedValues = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value);
      }
    }
    setSelectedStoreFromOptions(selectedValues);
  };

  const handleStoreToSelectChange = (event) => {
    const { options } = event.target;
    const selectedValues = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value);
      }
    }
    setSelectedStoreToOptions(selectedValues);
  };

  const handleFromToToChange = (data = null) => {
    const newFromStore = [];
    const newToStore = Array.from(toStoreOptions);
    storeOptions.forEach((element) => {
      if (!selectedStoreFromOptions.includes(element._id)) {
        newFromStore.push(element);
      } else {
        const isIdAvailable = newToStore.some(
          (item) => item._id === element._id
        );
        if (!isIdAvailable) {
          newToStore.push(element);
        }
      }
    });

    setStoreOptions(newFromStore);
    setToStoreOptions(newToStore);
    setValue("stores", newToStore);

    setSelectedStoreFromOptions([]);
    setSelectedStoreToOptions([]);
  };

  const handleToToFromChange = () => {
    const newToStore = [];
    const newFromStore = Array.from(storeOptions);
    toStoreOptions.forEach((element) => {
      if (!selectedStoreToOptions.includes(element._id)) {
        newToStore.push(element);
      } else {
        const isIdAvailable = newFromStore.some(
          (item) => item._id === element._id
        );
        if (!isIdAvailable) {
          newFromStore.push(element);
        }
      }
    });

    setStoreOptions(newFromStore);
    setToStoreOptions(newToStore);
    setValue("stores", newToStore);

    setSelectedStoreFromOptions([]);
    setSelectedStoreToOptions([]);
  };

  useEffect(() => {
    if (localUser?.country) {
      setSelectedCountry({
        value: localUser.country._id,
        label: `${localUser.country.name}-${localUser.country.code}`,
      });
      setValue("country", localUser.country._id);
    }

    if (localUser?.userType === "superAdmin") {
      getActiveCountries();
    } else {
      getStoreInfo();
      getPointInfo();
    }
    getTripTypeInfo();
  }, []);

  useEffect(() => {
    if (localUser?.userType === "superAdmin") {
      getStoreInfo();
      getPointInfo();
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (id) {
      setRouteId(id);
      getRouteInfo(id);
    }
  }, [id]);

  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1 })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setCountrySelectOptions(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const getTripTypeInfo = () => {
    const options = [
      { value: "pickUp", label: "Pick-up" },
      { value: "dropOff", label: "Drop-off" },
    ];
    setTripTypeOptions(options);
  };

  const getPointInfo = () => {
    const limit = 100;
    const page = 1;
    getRoutePointList({ limit, page, country: selectedCountry?.value })
      .then(async (response) => {
        const pointData = response.data;
        let options = pointData.map((element) => ({
          value: `${element._id}`,
          label: `${element.name}`,
        }));
        setPointOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getStoreInfo = () => {
    getNoRouteStores({ country: selectedCountry?.value })
      .then(async (response) => {
        const storeData = response.data;
        setStoreOptions(storeData);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getRouteInfo = (id) => {
    // setIsLoading(true)
    getSingleRoute(id)
      .then(async (response) => {
        setRouteData(response.data);
        const {
          name,
          routeCode,
          startingPoint,
          endingPoint,
          distance,
          startTime,
          duration,
          tripType,
          stores,
          country,
          tripUrgency,
          routeType,
        } = response.data;
        setValue("country", country?._id);
        setValue("name", name);
        setValue("routeCode", routeCode);
        if (routeType) {
          setValue("routeType", routeType);
          if (routeType === "multiple") {
            setRouteType({
              label: "Multiple Route",
              value: "multiple",
            });
          } else {
            setRouteType({
              label: "Single Route",
              value: "single",
            });
          }
        }
        if (startingPoint) {
          setValue("startingPoint", startingPoint._id);
          setSelectedStartingPointOption({
            label: startingPoint.name,
            value: startingPoint._id,
          });
        }
        if (endingPoint) {
          setValue("endingPoint", endingPoint._id);
          setSelectedEndingPointOption({
            label: endingPoint.name,
            value: endingPoint._id,
          });
        }
        setValue("distance", distance);
        setValue("startTime", startTime);
        setValue("duration", duration);
        setValue("tripType", tripType);

        if (stores && stores.length > 0) {
          setValue("stores", stores ? stores : []);
          setToStoreOptions(stores ? stores : []);
        }

        if (tripUrgency) {
          setValue("tripUrgency", tripUrgency);
          if (tripUrgency === "normal") {
            setSelectedTripUrgencyOption({
              label: "Normal",
              value: "normal",
            });
          } else {
            setSelectedTripUrgencyOption({
              label: "Emergency",
              value: "emergency",
            });
          }
        }

        let tripTypeLabel = "Pick-up";
        if (tripType == "dropOff") {
          tripTypeLabel = "Drop-off";
        }

        setSelectedTripTypeOption({
          label: tripTypeLabel,
          value: tripType,
        });

        setSelectedCountry({ label: country?.name, value: country?._id });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );

  const onSubmit = (data) => {
    console.log(data);
    if (routePointId) {
      toast
        .promise(
          updateRoute(data, routePointId),
          {
            loading: "Loading",
            success: "Route Updated Succesfully",
            error: (err) => {
              return err.response &&
                err.response.data &&
                err.response.data.message
                ? err.response.data.message
                : defaultErrorMessage;
            },
          },
          {
            id: "routePoint",
          }
        )
        .then(async (response) => {
          // console.log("response", response);
        })
        .catch((error) => console.error(error));
    } else {
      toast
        .promise(
          createRoute(data),
          {
            loading: "Loading",
            success: "Route Created Succesfully",
            error: (err) => {
              return err.response &&
                err.response.data &&
                err.response.data.message
                ? err.response.data.message
                : defaultErrorMessage;
            },
          },
          {
            id: "routePoint",
          }
        )
        .then(async (response) => {
          // console.log("response", response);
          reset();
          refreshCustomField();
        })
        .catch((error) => console.error(error));
    }
  };

  const refreshCustomField = () => {
    setSelectedStartingPointOption(null);
    setSelectedEndingPointOption(null);
    setSelectedTripTypeOption(null);
    setToStoreOptions([]);
    setSelectedCountry(null);
    setSelectedTripUrgencyOption({
      label: "Normal",
      value: "normal",
    });
    setValue("tripUrgency", "normal");
  };

  const onError = (err) => {
    console.error(err);
  };

  const handleChangeTripType = (selectedOption) => {
    if (selectedOption) {
      setSelectedTripTypeOption(selectedOption);
      setValue("tripType", selectedOption.value);
    } else {
      setSelectedTripTypeOption("");
      setValue("tripType", "");
    }
  };

  const handleChangeStartingPoint = (selectedOption) => {
    console.log("Selected Strting Point:", selectedOption);
    if (selectedOption) {
      setSelectedStartingPointOption(selectedOption);
      setValue("startingPoint", selectedOption.value);
    } else {
      setSelectedStartingPointOption("");
      setValue("startingPoint", "");
    }
  };

  const handleChangeEndingPoint = (selectedOption) => {
    console.log("Selected Ending Point:", selectedOption);
    if (selectedOption) {
      setSelectedEndingPointOption(selectedOption);
      setValue("endingPoint", selectedOption.value);
    } else {
      setSelectedEndingPointOption("");
      setValue("endingPoint", "");
    }
  };

  const filteredArray = storeOptions.filter((sourceItem) => {
    return !toStoreOptions.some(
      (targetItem) => targetItem._id === sourceItem._id
    );
  });

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedCountry(selectedOption);
      setValue("country", selectedOption.value);
    } else {
      setSelectedCountry(null);
      setValue("country", "");
    }
  };

  const handleChangeTripUrgency = (selectedOption) => {
    setSelectedStartingPointOption(null);
    setSelectedEndingPointOption(null);
    setSelectedStoreToOptions([]);
    if (selectedOption) {
      setSelectedTripUrgencyOption(selectedOption);
      setValue("tripUrgency", selectedOption.value);
    } else {
      setSelectedTripUrgencyOption("");
      setValue("tripUrgency", "");
    }
  };

  const handleChangeRouteType = (selectedOption) => {
    setSelectedStartingPointOption(null);
    setSelectedEndingPointOption(null);
    setSelectedStoreToOptions([]);
    if (selectedOption) {
      setRouteType(selectedOption);
      setValue("routeType", selectedOption.value);

      if (selectedOption.value === "multiple") {
        setSelectedTripUrgencyOption({
          label: "Normal",
          value: "normal",
        });
        setValue("tripUrgency", "normal");
      }
    } else {
      setRouteType("");
      setValue("routeType", "");
    }
  };

  return (
    <CCard className="mb-4">
      <CCardBody>
        <CRow>
          <CCol sm={5}>
            <h4 id="traffic" className="card-title mb-0">
              Create New Route
            </h4>
            {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
          </CCol>
          <CCol sm={7} className="d-none d-md-block"></CCol>
        </CRow>
        <hr />
        <br />
        <CForm onSubmit={handleSubmit(onSubmit, onError)}>
          <CRow className="mb-3">
            {localUser?.userType === "superAdmin" && (
              <CCol md={6}>
                <CRow>
                  <CFormLabel
                    htmlFor="name"
                    className="col-sm-3 col-form-label"
                  >
                    Country:
                  </CFormLabel>
                  <CCol md={8}>
                    <ReactSelect
                      value={selectedCountry}
                      onChange={handleCountryChange}
                      options={countrySelectOptions}
                      isClearable={true}
                      placeholder="Select Country"
                      className="w-100"
                    />
                  </CCol>
                </CRow>
              </CCol>
            )}

            {["superAdmin", "cvit", "admin"].includes(localUser?.userType) && (
              <>
                <CCol md={6}>
                  <CRow className="mb-3">
                    <CFormLabel
                      htmlFor="tripType"
                      className="col-sm-3 col-form-label"
                    >
                      Route Type:
                    </CFormLabel>
                    <CCol sm={8}>
                      <Select
                        value={routeType}
                        onChange={handleChangeRouteType}
                        options={[
                          {
                            value: "single",
                            label: "Same Route",
                          },
                          {
                            value: "multiple",
                            label: "Multiple Route",
                          },
                        ]}
                        placeholder="Select route type"
                        isClearable={true}
                      />
                      {errors.urgencyType?.message && (
                        <p className="error_text">
                          {errors.urgencyType?.message}
                        </p>
                      )}
                    </CCol>
                  </CRow>
                </CCol>
                <CCol md={6}>
                  <CRow className="mb-3">
                    <CFormLabel
                      htmlFor="tripType"
                      className="col-sm-3 col-form-label"
                    >
                      Urgency:
                    </CFormLabel>
                    <CCol sm={8}>
                      <Select
                        value={selectedTripUregnecyOption}
                        onChange={handleChangeTripUrgency}
                        options={[
                          {
                            value: "normal",
                            label: "Normal",
                          },
                          {
                            value: "emergency",
                            label: "Emergency",
                          },
                        ]}
                        placeholder="Select urgency type"
                        isClearable={true}
                      />
                      {errors.urgencyType?.message && (
                        <p className="error_text">
                          {errors.urgencyType?.message}
                        </p>
                      )}
                    </CCol>
                  </CRow>
                </CCol>
              </>
            )}
          </CRow>

          <CRow>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel htmlFor="name" className="col-sm-3 col-form-label">
                  Route Name:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput type="text" id="name" {...register("name")} />
                  {errors.name?.message && (
                    <p className="error_text">{errors.name?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="routeCode"
                  className="col-sm-3 col-form-label"
                >
                  Route Code:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="routeCode"
                    {...register("routeCode")}
                  />
                  {errors.routeCode?.message && (
                    <p className="error_text">{errors.routeCode?.message}</p>
                  )}
                </CCol>
              </CRow>
              {selectedTripUregnecyOption &&
              selectedTripUregnecyOption.value === "normal" &&
              routeType &&
              routeType.value === "single" ? (
                <>
                  <CRow className="mb-3">
                    <CFormLabel
                      htmlFor="startingPoint"
                      className="col-sm-3 col-form-label"
                    >
                      Starting Point:
                    </CFormLabel>
                    <CCol sm={8}>
                      <Select
                        value={selectedStartingPointOption}
                        onChange={handleChangeStartingPoint}
                        options={pointOptions}
                        isClearable={true}
                      />
                      {errors.startingPoint?.message && (
                        <p className="error_text">
                          {errors.startingPoint?.message}
                        </p>
                      )}
                    </CCol>
                  </CRow>
                  <CRow className="mb-3">
                    <CFormLabel
                      htmlFor="orderNumber"
                      className="col-sm-3 col-form-label"
                    >
                      Ending Point:
                    </CFormLabel>
                    <CCol sm={8}>
                      <Select
                        value={selectedEndingPointOption}
                        onChange={handleChangeEndingPoint}
                        options={pointOptions}
                        isClearable={true}
                      />
                      {errors.endingPoint?.message && (
                        <p className="error_text">
                          {errors.endingPoint?.message}
                        </p>
                      )}
                    </CCol>
                  </CRow>
                </>
              ) : (
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="tripType"
                    className="col-sm-3 col-form-label"
                  >
                    Trip Type:
                  </CFormLabel>
                  <CCol sm={8}>
                    <Select
                      value={selectedTripTypeOption}
                      onChange={handleChangeTripType}
                      options={tripTypeOptions}
                      isClearable={true}
                    />
                    {errors.tripType?.message && (
                      <p className="error_text">{errors.tripType?.message}</p>
                    )}
                  </CCol>
                </CRow>
              )}
            </CCol>

            <CCol sm={6} className="d-none d-md-block">
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="startTime"
                  className="col-sm-3 col-form-label"
                >
                  Start Time:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="time"
                    id="startTime"
                    {...register("startTime")}
                  />
                  {errors.startTime?.message && (
                    <p className="error_text">{errors.startTime?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="duration"
                  className="col-sm-3 col-form-label"
                >
                  Duration:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="duration"
                    {...register("duration")}
                  />
                  {errors.duration?.message && (
                    <p className="error_text">{errors.duration?.message}</p>
                  )}
                </CCol>
              </CRow>

              {selectedTripUregnecyOption &&
                selectedTripUregnecyOption.value === "normal" &&
                routeType &&
                routeType.value === "single" && (
                  <CRow className="mb-3">
                    <CFormLabel
                      htmlFor="tripType"
                      className="col-sm-3 col-form-label"
                    >
                      Trip Type:
                    </CFormLabel>
                    <CCol sm={8}>
                      <Select
                        value={selectedTripTypeOption}
                        onChange={handleChangeTripType}
                        options={tripTypeOptions}
                        isClearable={true}
                      />
                      {errors.tripType?.message && (
                        <p className="error_text">{errors.tripType?.message}</p>
                      )}
                    </CCol>
                  </CRow>
                )}

              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="distance"
                  className="col-sm-3 col-form-label"
                >
                  Distance.:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="distance"
                    {...register("distance")}
                  />
                  {errors.distance?.message && (
                    <p className="error_text">{errors.distance?.message}</p>
                  )}
                </CCol>
              </CRow>
            </CCol>

            {selectedTripUregnecyOption &&
              selectedTripUregnecyOption.value === "normal" &&
              routeType &&
              routeType.value === "single" && (
                <>
                  <CCol sm={5} className="d-none d-md-block">
                    <CRow className="mb-3">
                      <CFormLabel
                        htmlFor="startTime"
                        className="col-sm-3 col-form-label"
                      >
                        Store:
                      </CFormLabel>
                      <CCol sm={12}>
                        <select
                          name="storeFrom[]"
                          value={selectedStoreFromOptions}
                          id="multiselect"
                          className="form-control"
                          size="8"
                          multiple="multiple"
                          onChange={handleStoreFromSelectChange}
                        >
                          {filteredArray &&
                            filteredArray.map((store, index) => (
                              <option key={index} value={store._id}>
                                {store.name}
                              </option>
                            ))}
                        </select>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol
                    sm={2}
                    className="d-none d-md-block text-center"
                    style={{ padding: "4%" }}
                  >
                    <CRow className="mb-3">
                      <CCol sm={12}>
                        <CButton
                          color="secondary"
                          style={{ color: "white" }}
                          onClick={handleFromToToChange}
                        >
                          <CIcon icon={cilArrowThickRight} />
                        </CButton>
                      </CCol>
                    </CRow>
                    <CRow className="mb-3">
                      <CCol sm={12}>
                        <CButton
                          color="secondary"
                          style={{ color: "white" }}
                          onClick={handleToToFromChange}
                        >
                          <CIcon icon={cilArrowThickLeft} />
                        </CButton>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol sm={5} className="d-none d-md-block">
                    <CRow className="mb-12">
                      <CFormLabel
                        htmlFor="startTime"
                        className="col-sm-6 col-form-label"
                      >
                        Assigned Store:
                      </CFormLabel>
                      <CCol sm={12}>
                        <select
                          name="storeTo[]"
                          id="multiselect_to"
                          value={selectedStoreToOptions}
                          className="form-control"
                          size="8"
                          multiple="multiple"
                          onChange={handleStoreToSelectChange}
                        >
                          {toStoreOptions &&
                            toStoreOptions.map((store, index) => (
                              <option key={index} value={store._id}>
                                {store.name}
                              </option>
                            ))}
                        </select>

                        {errors.stores?.message && (
                          <p className="error_text">{errors.stores?.message}</p>
                        )}
                      </CCol>
                    </CRow>
                  </CCol>
                </>
              )}

            <div className="d-flex justify-content-end mt-3">
              <CButton type="submit" color="primary" className="px-5 py-2">
                Submit
              </CButton>
            </div>
          </CRow>
        </CForm>
      </CCardBody>
    </CCard>
  );
};

export default CreateRoute;
